export const EVENTBUS_PUBLISH = 'EVENTBUS_PUBLISH';

export type Actions = {
  EVENTBUS_PUBLISH: { type: typeof EVENTBUS_PUBLISH, payload: any | null}
  };

export const actionCreators = {
     eventBusPublish:  (payload: any): Actions[typeof EVENTBUS_PUBLISH] => ({
        type: EVENTBUS_PUBLISH,
        payload,
    }),
  };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/eventLogging/actions.ts